import ActivitesApi from "../api/activitiesApi";
import * as types from "./actionTypes";

function getUserActivitiesStarted() {
  return { type: types.ACTIVITIES_GET_STARTED };
}

function getUserActivitiesRejected(err: any) {
  return {
    type: types.ACTIVITIES_GET_REJECTED,
    message: err.message,
    stack: err.stack,
  };
}

function getUserActivitiesFulfilled(activities: any, persons: any) {
  return {
    type: types.ACTIVITIES_GET_FULFILLED,
    payload: {
      activities,
      persons,
    },
  };
}

export function getMyActivities() {
  return (dispatch: any) => {
    dispatch(getUserActivitiesStarted());
    ActivitesApi.getMyActivities()
      .then((data) => {
        dispatch(getUserActivitiesFulfilled(data.activities, data.persons));
      })
      .catch((er) => {
        dispatch(getUserActivitiesRejected(er));
      });
  };
}
